/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */


export const SNACKBAR_ALERT_DEFAULT_PROPS = {
  show: true,
  autoHideDuration: 5000,
  message: '',
  severity: 'success' as 'success' | 'error'
};
export const ATTR_MAX_COUNT = 50;
export const ATTR_MAX_COUNT_WARN = `You can add a maximum of ${ATTR_MAX_COUNT} attributes.`;
export const ALL_ATTR_LISTED_WARN = `All attributes are listed. There are no more attributes to add.`;
export const ATTR_ROWS_CROSSED_MAX_AVAILABLE_WARN = `You have reached the maximum available attributes.`;
export const DIMENSION_LEVEL_LIMIT = 50;
export const DROPDOWN_WIDTH = 260;
export const DROPDOWN_WIDTH_LARGE = 550;
export const DROPDOWN_MAX_HEIGHT = 350;
export const POLICY_NAME_VALIDATION_MSG = 'Policy name is required';

export const POLICY_NAMESPACE_VALIDATION_MSG = 'Policy namespace is required';
export const POLICY_DESC_VALIDATION_MSG = 'Policy description is required';
export const POLICY_MODULE_VALIDATION_MSG = 'Module is required';
export const POLICY_ENTITY_VALIDATION_MSG = 'Entity is required';
export const POLICY_MEASURE_GROUP_VALIDATION_MSG = 'Measure Group is required';
export const POLICY_MEASURE_VALIDATION_MSG = 'Measure is required';
export const POLICY_HIERARCHY_VALIDATION_MSG = 'Product hierarchy is required';
export const ENTITY_ATTRIBUTE_VALIDATION_MSG = 'Attribute is required';
export const ENTITY_ATTRIBUTE_ACTION_VALIDATION_MSG = 'Attribute Action is required';
export const ENTITY_ATTRIBUTE_VALUE_VALIDATION_MSG = 'Value is required';
export const ENTITY_ATTRIBUTE_VALUE_ACTION_VALIDATION_MSG = 'Value Action is required';

export const POLICY_ACTION_VALIDATION_MSG = 'Action is required';
export const POLICY_CREATE_SUCCESS = 'Policy {0} has been created and assigned to role {1}';
export const POLICY_EDIT_SUCCESS = 'Policy {0} has been edited and assigned to role {1}';
export const POLICY_CREATE_ERROR = 'Error while creating policy : ';
export const POLICY_EDIT_ERROR = 'Error while editing policy : ';
export const POLICY_ASSIGN_ERROR = 'Error while assigning policy to Role';

export const POLICY_NAME_LABEL = 'Name';
export const POLICY_DESC_LABEL = 'Description';
export const POLICY_MODULE_LABEL = 'Module';
export const POLICY_RESOURCE_LABEL = 'Resource';
export const POLICY_ENTITY_MODEL_LABEL = 'Model';
export const POLICY_ENTITY_LABEL = 'Entity';
export const POLICY_HIERARCHY_LABEL = 'Product Hierarchy';
export const POLICY_ACTIONS_LABEL = 'Actions';
export const MEASURES_GROUP_LABEL = 'Measures Group';
export const ADD_POLICY_DIALOG_TITLE = "Add Policy Rule";
export const POLICY_DIMENSION_LABEL = 'Dimension';

export const EDIT_POLICY_DIALOG_TITLE = "Edit Policy Rule";
export const SAVE_BTN_TEXT = 'Create Policy';
export const UPDATE_POLICY_BTN_TEXT = 'Update Policy';
export const CANCEL_BTN_TEXT = 'Cancel';
export const ADD_ATTRIBUTE_BTN_TEXT = 'Add';

export const GET_HIERARCHY_DATA_ERROR = 'Error in fetching hierarchy data: {0}';
export const GET_ENTITIES_DATA_ERROR = 'Error in fetching entities data: {0}';
export const GET_ENTITIES_DATA_MODEL_ERROR = 'Error in fetching entities data model: {0}';
export const GET_ENTITIES_ATTRIBUTES_DATA_ERROR = ' does not contain attributes and its data. Publish resource schema to create attribute and data level policies.';
export const GET_SECURABLE_ATTRIBUTES_DATA_ERROR = 'The chosen entity does not contain any authorization information which are required for creating policies at attribute and data permissions level.';
export const GET_ENTITIES_NAMESPACE_DATA_ERROR = 'Error in fetching namespace data: {0}';
export const GET_ENTITIES_RESOURCE_DATA_ERROR = 'Error in fetching resources data: {0}';
export const GET_DIMENSIONS_ERROR = 'Error in fetching dimensions data: {0}';
export const GET_DIMENSIONS_ATTRIBUTES_ERROR = 'Error in fetching dimensions attributes data: {0}';
export const AUTHORISING_HIERARCHY_ERROR = 'There is no Authorising Hierarchy for the selected Dimension.';


export const POLICY_ENTITY = 'entity';
export const POLICY_RESOURCE = 'resource';
export const POLICY_MODULE = 'module';
export const POLICY_HIERARCHY = 'hierarchy';
export const POLICY_HIERARCHY_ALL = 'hierarchyAll';
export const POLICY_HIERARCHY_ALL_ACTIONS = 'hierarchyAllActions';
export const POLICY_DIMENSION = 'dimension';
export const POLICY_DIMENSION_SELECTALL = 'selectAllDimension';
export const POLICY_DIMENSION_MEMBERS = 'members';
export const POLICY_FUNCTIONAL_RULE_DROPDOWN_HELPER_TEXT = 'A functional policy defines access to an application and its features, such as UI controls.';
export const POLICY_DATA_RULE_DROPDOWN_HELPER_TEXT = 'A data policy defines access to data contained in an application module and resource.';
export const POLICY_ENTITIES_RULE_DROPDOWN_HELPER_TEXT = 'An entity policy defines access to a BYDM (Platform Data Cloud) entity. A BYDM entity represents a real-world object such as location or item.';
export const POLICY_LOGICAL_DIMENSION_RULE_DROPDOWN_HELPER_TEXT = 'A dimension policy defines access to a dimension. A dimension is a set of data attributes pertaining to an entity of interest to a business, such as customers, products, stores, and time.';
export const POLICY_MEASURE_RULE_DROPDOWN_HELPER_TEXT = 'A measure policy defines access to a measure. A measure is a value consisting of stored or calculated data on which further calculation can be made, such as a price measure, a demand forecast measure etc.';
export const POLICY_MODULE_HELPER_TEXT = 'An app in the portal';
export const POLICY_ENTITY_HELPER_TEXT = 'Data model of your company’s data (e.g. location)';
export const POLICY_HIERARCHY_HELPER_TEXT = 'Subset of data model that user has access to';
export const POLICY_ACTION_HELPER_TEXT = 'Actions you can perform on the entities';
export const POLICY_MEASURE_GROUP_HELPER_TEXT = 'Measure Groups';
export const ENTITY_TITLE = 'Entity Permissions';
export const ENTITY_ATTRIBUTE_TITLE = 'Attribute Permissions';
export const ENTITY_DATA_TITLE = 'Data Permissions';
export const ENTITY_ATTRIBUTE_LABEL = 'Attribute';
export const ENTITY_VALUE_LABEL = 'Value';
export const ENTITY_ATTRIBUTE_ACTION_LABEL = 'Action on Attribute';
export const ENTITY_ATTRIBUTE_VALUE_ACTION_LABEL = 'Attribute Actions';
export const DISPLAY_NAME = 'displayName';
export const ID = 'id';
export const POLICY_TYPE = "Policy Type";
export const DELETE = 'Delete';
export const ALL = "All";
export const POLICY_NAME = "policyName";
export const POLICY_DESCRIPTION = 'policyDescription';
export const FUNCTION = 'Function';
export const FUNCTIONAL_ENTITY_HELPER_TEXT = 'Function can be an app or a feature in an app';
export const FUNCTIONAL = 'functional';
export const WARNING = 'Caution: Users with these permissions may gain elevated access. Assign carefully and restrict to administrators.';
export const ALERT_PERMISSIONS = ['role.read_assign', 'role.read_write', 'role.read', 'user.read_write', 'user.read', 'machine.read_write', 'machine.read', 'subject.read_assign', 'realm_settings.read_write', 'idp_role.read_write'];
export const DATA = 'data';
export const ENTITIES = 'entity';
export const POLICY_ENTITY_MODEL = 'policyEntityModel';
export const POLICY_ENTITY_DATA = 'policyEntity';
export const POLICY_ENTITY_ACTION = 'policyAction';
export const ENTITY_OPERATOR_LABEL = 'Operator';
export const POLICY_RESOURCE_ACTION = 'policyResource';
export const POLICY_NAMESPACE_ACTION = 'policyNamespace';
export const DATA_PLATFORM_NAMESPACE = 'by.data';
export const DIMENSION = 'logicalmodel-dimension-access-control';
export const DIMENSIONV2 = 'logicalmodel-dimension-access-control-v2';
export const MEASURE = 'logicalmodel-measure-access-control';
export const HIERARCHY = 'Hierarchy';
export const HIERARCHY_ACCESS_CONTROL = 'Hierarchy Access Control';
export const SELECT_ALL_TEXT = 'Select all in';
export const SELECT_ALL = 'Select All';
export const SELECTION_MESSAGE = 'If multiple families are selected, Sub-Family and Sub-Sub-Family will be disabled.';
export const DIMENSION_ATTRIBUTE_TITLE = 'Attribute Access Control';
export const DIMENSION_ATTRIBUTE_ACTION_TITLE = 'Attribute Action';
export const EMPTY_LIST_TITLE = "It's empty here";
export const EMPTY_LIST_SUB_TITLE = "Select the item and tranfer from the left side panel list";
export const NO_DIMENSION_ATTR = "There are no attributes available for the selected dimension.";

export const MEASURES = "Measures";
export const MEASURE_GROUP = "Measure Group";
export const MEASURE_POLICY_TYPE_LABEL = "Logicalmodel Measure";
export const MEASURE_POLICY_TYPE = "logicalmodel-measure-access-control";
export const MEASURE_GROUP_POLICY_TYPE = "logicalmodel-measuregroup-access-control";

export const OPERATOR_ITEMS = [{
  key: 'equals', displayName: 'equals'
}];

export const POLICY_TYPE_LIST = [
  { id: 1, displayName: 'Functional', key: FUNCTIONAL, default: true, description: POLICY_FUNCTIONAL_RULE_DROPDOWN_HELPER_TEXT },
  { id: 2, displayName: 'Data', key: DATA, default: false, description: POLICY_DATA_RULE_DROPDOWN_HELPER_TEXT },
  { id: 3, displayName: 'Entities', key: ENTITIES, default: false, description: POLICY_ENTITIES_RULE_DROPDOWN_HELPER_TEXT },
  { id: 4, displayName: 'Logicalmodel Dimension', key: DIMENSION, default: false, description: POLICY_LOGICAL_DIMENSION_RULE_DROPDOWN_HELPER_TEXT },
  { id: 5, displayName: 'Logicalmodel Dimension V2', key: DIMENSIONV2, default: false, description: POLICY_LOGICAL_DIMENSION_RULE_DROPDOWN_HELPER_TEXT },
  { id: 6, displayName: 'Logicalmodel Measure', key: MEASURE, default: false, description: POLICY_MEASURE_RULE_DROPDOWN_HELPER_TEXT }
];

export const POLICY_TYPE_WITHOUT_DIMENSION_V2_LIST = [
  { id: 1, displayName: 'Functional', key: FUNCTIONAL, default: true, description: POLICY_FUNCTIONAL_RULE_DROPDOWN_HELPER_TEXT },
  { id: 2, displayName: 'Data', key: DATA, default: false, description: POLICY_DATA_RULE_DROPDOWN_HELPER_TEXT },
  { id: 3, displayName: 'Entities', key: ENTITIES, default: false, description: POLICY_ENTITIES_RULE_DROPDOWN_HELPER_TEXT },
  { id: 4, displayName: 'Logicalmodel Dimension', key: DIMENSION, default: false, description: POLICY_LOGICAL_DIMENSION_RULE_DROPDOWN_HELPER_TEXT },
  { id: 6, displayName: 'Logicalmodel Measure', key: MEASURE, default: false, description: POLICY_MEASURE_RULE_DROPDOWN_HELPER_TEXT }
];

export const POLICY_SYNTAX_VERSION = '1.0.0';
export const POLICY_SYNTAX_VERSION_V2 = "2.0.0";
export const POLICY_MODEL_VERSION = 'BYLM 1.0';
export const POLICY_MODEL_VERSION_V2 = 'BYLM 2.0';
export const HIERARCHY_TABLE_LABEL = {
  HIERARCHY: 'Hierarchy',
  LEVELS_PERMISSIONS: 'How many levels down will permissions apply',
  ACTIONS: 'Actions',
};
export const AUTHORIZING = 'Authorizing';
export const ENABLE = 'Enable';
export const DISABLE = 'Disable';
export const DATA_SCOPE_ACCESS_FOR = 'Data Scope Access for';
export const OPTIONAL = 'optional';
export const AUTHORIZING_HIERARCHY_DESCRIPTION = 'Authorizing hierarchy has additional permissions not configurable for other hierarchies';
export const ATTR_MAX_COUNT_MSG = 'Maximum of 50 attributes can be added.';
export const NO_AUTHORIZING_HIERARCHY =
  'There is no authorising hierarchy for the selected dimension. At least one authorising hierarchy is required for defining policy at hierarchy level.';

export const CREATE_BUILTIN_POLICY = 'Create Built-in Policy';
export const EDIT_BUILTIN_POLICY = 'Edit Built-in Policy';
export const SAVE = 'Save';
export const INFO_ALERT =
  'Built-in policies are pre-defined application policies based on entity policy that can only be associated with' +
  ' global roles in order to provide fine grained authorization for application resources.';
export const BUILTIN_POLICY_CREATE_SUCCESS = 'Built-in policy {0} has been created';
export const BUILTIN_POLICY_EDIT_SUCCESS = 'Built-in policy {0} has been edited';
export const NO_RECORDS_IN_SEARCH = 'No records available.';
export const VIEW_POLICY = 'View Policy';
export const ATTRIBUTE_NAME='Attribute Name';
export const NAMESPACE_LABEL='Namespace';
